import axios from 'axios';

const getLocationOptions = location => {
  return axios.get(
    `https://api.opencagedata.com/geocode/v1/json?q=${location}&key=b3a3b88eaac14d1990d0f9d970dda4f2&language=en&pretty=1&no_annotations=1&countrycode=gb&min_confidence=5`
  );
};

export default getLocationOptions;
